import {
  IHighRiskSupplementDetailsResponseDTO,
  IHighRiskSupplementResponseDTO,
  IRiskSupplementImagesResponseDTO,
} from '@interfaces/highRiskSupplements';

import { RiskSupplementWarningType } from './riskSupplementWarningType';

export class HighRiskSupplementDetails {
  comments: string;

  drugClasses: string[];

  id: number | null;

  ingredients: string[];

  fdaLetter: string;

  name: string;

  productInfo: string;

  riskSupplementCategory: string;

  riskSupplementCompany: string;

  statusDate: string;

  warningTypes: RiskSupplementWarningType[];

  images: IRiskSupplementImagesResponseDTO[];

  constructor(dto: IHighRiskSupplementDetailsResponseDTO) {
    const data: IHighRiskSupplementDetailsResponseDTO =
      dto && typeof dto === 'object' ? dto : ({} as IHighRiskSupplementDetailsResponseDTO);
    this.id = typeof data.id === 'number' ? data.id : null;
    this.name = typeof data.name === 'string' ? data.name : '';
    this.statusDate = typeof data.statusDate === 'string' ? data.statusDate : '';
    this.comments = typeof data.comments === 'string' ? data.comments : '';
    this.drugClasses = Array.isArray(data.drugClasses)
      ? data.drugClasses.map(item => (typeof item === 'string' ? item : ''))
      : [];
    this.ingredients = Array.isArray(data.ingredients)
      ? data.ingredients.map(item => (typeof item === 'string' ? item : ''))
      : [];
    this.warningTypes = Array.isArray(data.warningTypeDtos)
      ? data.warningTypeDtos.map(item => new RiskSupplementWarningType(item))
      : [];
    this.fdaLetter = typeof data.fdaLetter === 'string' ? data.fdaLetter : '';
    this.productInfo = typeof data.productInfo === 'string' ? data.productInfo : '';
    this.riskSupplementCategory =
      typeof data.riskSupplementCategory === 'string' ? data.riskSupplementCategory : '';
    this.riskSupplementCompany =
      typeof data.riskSupplementCompany === 'string' ? data.riskSupplementCompany : '';
    this.images = Array.isArray(data.images)
      ? data.images.map(image => ({
          id: typeof image?.id === 'number' ? image.id : null,
          name: typeof image?.name === 'string' ? image.name : '',
          url: typeof image?.url === 'string' ? image?.url : '',
        }))
      : [];
  }
}
